import langContext from "contexts/lang.context";
import React from "react";

/**
 * Permite obtener los textos del idioma actual
 * @returns contexto del lenguaje
 */
export default function useLang() {
    return React.useContext(langContext);
}